import { NgModule } from '@angular/core';
import {
  AssetActualFaultInputComponent,
  AssetFaultViewResolutionNotesDialogComponent,
} from './forms/inputs/actual-faults-input.component';
import { CommonModule } from '@angular/common';
import { SharedInputModule } from '../../shared/modules/shared-input.module';
import { SharedModule } from '../../shared/modules/shared.module';
import {
  AssetFaultReportDetailsDialogComponent,
  AssetFaultResolutionDetailsDialogComponent,
  AssetViewActualFaultsComponent,
} from './view/components/actual-faults/actual-faults-view.component';
import { RouterModule } from '@angular/router';
import { AssetsViewJobDefectsButtonComponent, AssetsViewJobDefectsDialogComponent } from './shared/components/buttons/view-job-defects-button.component';
import { ViewAssetDefectsButtonComponent } from './shared/components/buttons/view-asset-defects-button.component';
import { AssetVariantInputComponent } from './forms/inputs/variant-input.component';
import { AssetViewVariantComponent } from './view/components/variant/view-variant.component';

@NgModule({
  imports: [
    CommonModule,
    SharedInputModule,
    SharedModule,
    RouterModule,
  ],
  declarations: [
    AssetActualFaultInputComponent,
    AssetViewActualFaultsComponent,
    AssetFaultResolutionDetailsDialogComponent,
    AssetFaultReportDetailsDialogComponent,
    AssetFaultViewResolutionNotesDialogComponent,
    AssetsViewJobDefectsButtonComponent,
    AssetsViewJobDefectsDialogComponent,
    ViewAssetDefectsButtonComponent,
    AssetVariantInputComponent,
    AssetViewVariantComponent,
  ],
  entryComponents: [
    AssetActualFaultInputComponent,
    AssetViewActualFaultsComponent,
    AssetFaultResolutionDetailsDialogComponent,
    AssetFaultReportDetailsDialogComponent,
    AssetFaultViewResolutionNotesDialogComponent,
    AssetsViewJobDefectsDialogComponent,
    AssetVariantInputComponent,
    AssetViewVariantComponent,
  ],
  exports: [
    AssetActualFaultInputComponent,
    AssetViewActualFaultsComponent,
    AssetsViewJobDefectsButtonComponent,
    ViewAssetDefectsButtonComponent,
    AssetVariantInputComponent,
    AssetViewVariantComponent,
  ],
})
export class AssetsSharedModule {}